import type { ButtonHTMLAttributes } from 'react'

interface SwatchButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'style' | 'type'> {
  /** CSS color painted as the swatch fill (e.g. a curated palette entry's dot color). */
  color: string
  selected?: boolean
  /** Visual "unavailable, taken by something else" dimming — kept distinct
   *  from `disabled` (which also fires for a generic saving-in-flight state
   *  that should NOT look dimmed). */
  dimmed?: boolean
}

/**
 * Small circular color-swatch selector (e.g. Settings › color pickers).
 * NEVER hand-roll a raw <button> for this — see DESIGN.md § 8c.
 */
export function SwatchButton({ color, selected, dimmed, disabled, ...rest }: SwatchButtonProps) {
  return (
    <button
      {...rest}
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      style={{ backgroundColor: color }}
      className={
        'w-6 h-6 rounded-full transition-shadow focus:outline-none ' +
        'focus-visible:ring-2 focus-visible:ring-primary/50 focus-visible:ring-offset-1 focus-visible:ring-offset-surface-container-lowest ' +
        (selected ? 'ring-2 ring-primary ring-offset-1 ring-offset-surface-container-lowest ' : '') +
        (dimmed ? 'opacity-40 cursor-not-allowed' : '')
      }
    />
  )
}
